@if (!field['isHidden']) {
  <div
    class="formly__field form-group formly-style mb-2"
    >
    <label [attr.for]="id" class="col-form-label formly__label"
           [ngClass]="{
               'col-sm-6': !field.styles?.columnWidth,
               'col-sm-12': field.styles?.columnWidth
           }"
      >
      {{displayText}} :
      @if (to.required && to.hideRequiredMarker !== true) {
        <i class="required">*</i>
      }
    </label>
    <div
        [ngClass]="{
               'col-sm-6': !field.styles?.columnWidth,
               'col-sm-12': field.styles?.columnWidth
           }"
      >
      <div
        [ngClass]="{'error-wrapper': error?.type === 'error', 'warning-wrapper': error?.type === 'warning'}">
        <ng-template #fieldComponent></ng-template>
        @if (error) {
          <div [ngClass]="{'error': error.type === 'error', 'warning': error.type === 'warning'}">
            <h1>
              @if (error.type === 'error') {
                <span class="badge rounded-circle badge-danger icon">i</span>
              }
              @if (error.type === 'warning') {
                <span class="badge rounded-circle badge-primary icon">i</span>
              }
              {{error.title}}
            </h1>
            <p class="error-message">{{error.message}}</p>
          </div>
        }
      </div>
    </div>
    @if (showError && showErrorOnLoad) {
      <div class="offset-6 col-sm-6 d-block">
        <div class="invalid-feedback">
          <span class="arrow-up"></span>
          <atom-image [type]="'icon'" [src]="icons.Warning_triangle" [color]="colors.White"></atom-image>
          <formly-validation-message [field]="field"></formly-validation-message>
        </div>
      </div>
    }
  </div>
}
